import { Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IdleService {
  public onTimeoutWarning$ = new Subject<number>();
  public onTimeout$ = new Subject<void>();

  constructor(private idle: Idle) {
    const idleTimeout = environment.idleTimeoutSeconds;
    const warningDuration = environment.timeoutWarningSeconds;

    idle.setIdle(idleTimeout - warningDuration);
    idle.setTimeout(warningDuration);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onTimeoutWarning.subscribe((countdown: number) => {
      this.onTimeoutWarning$.next(countdown);
    });

    idle.onTimeout.subscribe(() => {
      this.onTimeout$.next();
    });
  }

  startWatching() {
    this.idle.watch();
  }

  stopWatching() {
    this.idle.stop();
  }

  resetTimer() {
    this.idle.watch();
  }
}
